export default __webpack_public_path__ + "media/images/invalid-9895197a7a3bb9fbd1ea2daa09a035da.svg";